<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="mini">
      <div class="mb-3 d-flex flex-row">
        <div style="flex: 1" class="pr-2">
          <h6 style="color: #101010">
            {{ $l('form_header_base') || '客户信息' }}
          </h6>
          <p style="font-size: 14px; color: #6c6c6c" class="m-0 text-truncate">
            {{
              $l('form_desc_base') ||
              '根据操作指引填写客户基本信息、客户部门及产品线、客户方联系人、客户账务信息、配置对接客户的服务团队成员'
            }}
          </p>
        </div>
        <div class="cust-logo-display" @click="custLogoVisible = true">
          <el-image
            v-if="formData.bigImageCode"
            :src="formData.bigImageUrl"
            style="width: 100%; height: 100%"
            fit="contain"
          />
          <span v-else>LOGO</span>
        </div>
      </div>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_custName') || '客户公司名称'"
            prop="custName"
          >
            <el-input
              v-model="formData.custName"
              :placeholder="
                $l('form_placeholder_custName') || '请输入客户公司名称'
              "
              maxlength="200"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_businessLicense') || '客户公司税号'"
            prop="businessLicense"
          >
            <el-input
              v-model="formData.businessLicense"
              :placeholder="
                $l('form_placeholder_businessLicense') || '请输入客户公司税号'
              "
              maxlength="50"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_region') || '所在国家'"
            prop="regionCode"
          >
            <dict-select
              v-model="formData.regionCode"
              :selectedLabel.sync="formData.regionName"
              :placeholder="$l('form_placeholder_region') || '请选择所在国家'"
              url="/master/common/dict/biz"
              :body="{ dictType: 'region' }"
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_custAddress') || '客户经营地址'"
            prop="custAddress"
          >
            <el-input
              v-model="formData.custAddress"
              :placeholder="
                $l('form_placeholder_custAddress') || '请输入客户经营地址'
              "
              maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_contactMobile') || '客户联系电话'"
            prop="contactMobile"
          >
            <el-input
              v-model="formData.contactMobile"
              :placeholder="
                $l('form_placeholder_contactMobile') || '请输入客户联系电话'
              "
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div class="my-3">
        <h6 style="color: #101010">
          {{ $l('form_header_bizSet') || '业务设置' }}
        </h6>
        <p style="font-size: 14px; color: #6c6c6c" class="m-0 text-truncate">
          {{
            $l('form_desc_bizSet') ||
            '填写该客户在后续业务操作中，所需使用的相关设置定义'
          }}
        </p>
      </div>

      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_custShortName') || '客户简称'"
            prop="custShortName"
          >
            <el-input
              v-model="formData.custShortName"
              :placeholder="
                $l('form_placeholder_custShortName') || '请输入客户简称'
              "
              maxlength="200"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_customerBizType') || '客户类型'"
            prop="customerBizType"
          >
            <dict-select
              v-model="formData.customerBizType"
              :placeholder="
                $l('form_placeholder_customerBizType') || '请选择客户类型'
              "
              url="/digitalCenter/common/dict/system"
              :body="{ dictType: 'customerBizType' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_customerType') || '客户性质'"
            prop="customerType"
          >
            <dict-select
              v-model="formData.customerType"
              :placeholder="
                $l('form_placeholder_customerType') || '请选择客户性质'
              "
              url="/digitalCenter/common/dict/biz"
              :body="{ dictType: 'customerType' }"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_sales') || '接待人员'"
            prop="salesCode"
          >
            <dict-select
              v-model="formData.salesCode"
              :selectedLabel.sync="formData.salesName"
              :placeholder="$l('form_placeholder_sales') || '请选择接待人员'"
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
              @change="salesChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_riskAssessor') || '财务风险评估人'"
            prop="riskAssessorCode"
          >
            <dict-select
              v-model="formData.riskAssessorCode"
              :selectedLabel.sync="formData.riskAssessorName"
              :placeholder="
                $l('form_placeholder_riskAssessor') || '请选择财务风险评估人'
              "
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('form_label_dep') || '业务部门'"
            prop="depCode"
          >
            <dep-cascader
              :lastValue.sync="formData.depCode"
              :pathLabels.sync="formData.orgDepFullName"
              :placeholder="$l('form_placeholder_dep') || '请选择业务部门'"
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_managerApproval') || '部门主管审批人'" prop="managerApprovalBy">
            <dict-select
              v-model="formData.managerApprovalBy"
              :selectedLabel.sync="formData.managerApprovalByName"
              :placeholder="this.$l('form_placeholder_managerApproval') ||'请选择部门主管审批人'"
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_approver') || '审批负责人'"
            prop="approverCode"
          >
            <dict-select
              v-model="formData.approverCode"
              :selectedLabel.sync="formData.approverName"
              :placeholder="
                $l('form_placeholder_approver') || '请选择审批负责人'
              "
              url="/master/common/dict/baseUserSelect"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="mt-3 mb-1">
            <h6>
              <span class="text-danger">*</span>
              <span style="color: #101010">
                {{ $l('form_label_customerBackground') || '客户背景调查' }}
              </span>
            </h6>
            <p
              style="font-size: 14px; color: #6c6c6c"
              class="m-0 text-truncate"
            >
              {{
                $l('form_paragraph_customerBackground') ||
                '填写该客户在后续业务操作中，所需使用的相关设置定义'
              }}
            </p>
          </div>
          <el-form-item prop="customerBackground">
            <template #label> </template>
            <div>
              <Editor v-model="formData.customerBackground" />
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <CustLogo
      :visible.sync="custLogoVisible"
      :bigImageCode="formData.bigImageCode"
      :bigImageUrl="formData.bigImageUrl"
      :middleImageCode="formData.middleImageCode"
      :middleImageUrl="formData.middleImageUrl"
      :smallImageCode="formData.smallImageCode"
      :smallImageUrl="formData.smallImageUrl"
      @change="logoChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import Editor from '@/views/digital/components/editor'
import CustLogo from '../cust-logo'
export default {
  components: { Editor, CustLogo },
  mixins: [EditLoading],
  props: { custCode: { type: String, default: '' } },
  data() {
    return {
      formData: {
        bigImageCode: '',
        bigImageUrl: '',
        middleImageCode: '',
        middleImageUrl: '',
        smallImageCode: '',
        smallImageUrl: '',
        depCode: '',
        orgDepFullName: '',
      },
      rules: {
        custName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custName') || '请输入客户公司名称',
            trigger: 'blur',
          },
        ],
        businessLicense: [
          {
            required: true,
            message:
              this.$l('form_placeholder_businessLicense') ||
              '请输入客户公司税号',
            trigger: 'blur',
          },
        ],
        regionCode: [
          {
            required: true,
            message: this.$l('form_placeholder_region') || '请选择所在国家',
            trigger: 'change',
          },
        ],
        custAddress: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custAddress') || '请输入客户经营地址',
            trigger: 'blur',
          },
        ],
        contactMobile: [
          {
            required: true,
            message:
              this.$l('form_placeholder_contactMobile') || '请输入客户联系电话',
            trigger: 'blur',
          },
        ],
        custShortName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_custShortName') || '请输入客户简称',
            trigger: 'blur',
          },
        ],
        customerBizType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerBizType') || '请选择客户类型',
            trigger: 'change',
          },
        ],
        customerType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerType') || '请选择客户性质',
            trigger: 'change',
          },
        ],
        riskAssessorCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_riskAssessor') ||
              '请选择财务风险评估人',
            trigger: 'change',
          },
        ],
        salesCode: [
          {
            required: true,
            message: this.$l('form_placeholder_sales') || '请选择接待人员',
            trigger: 'change',
          },
        ],
        depCode: [
          {
            required: true,
            message: this.$l('form_placeholder_dep') || '请选择业务部门',
            trigger: 'change',
          },
        ],
        approverCode: [
          {
            required: true,
            message: this.$l('form_placeholder_approver') || '请选择审批负责人',
            trigger: 'change',
          },
        ],
        managerApprovalBy: [
          {
            required: true,
            message: this.$l('form_placeholder_managerApproval') ||'请选择部门主管审批人',
            trigger: 'change',
          },
        ],
        customerBackground: [
          {
            required: true,
            message:
              this.$l('form_placeholder_customerBackground') ||
              '请输入客户背景调查',
            trigger: 'blur',
          },
        ],
      },
      custLogoVisible: false,
      salesUserInfo: {},
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
  },
  watch: {
    userInfo: {
      handler() {
        if (this.formData.salesCode) return
        const { userCode, userName, userNameEn } = this.userInfo
        this.formData.salesCode = userCode || ''
        this.formData.salesName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
        if (userCode) this.salesChange(userCode)
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body
      this.formData = data
    },
    validate() {
      return validate.formValidate([this.$refs.form])
    },
    async complete() {
      if (!(await this.validate())) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerSaveBaseApi({
          ...this.formData,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return false

      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return false
      }

      this.$emit('update:custCode', body)
      return true
    },
    logoChange({
      bigImageCode,
      bigImageUrl,
      middleImageCode,
      middleImageUrl,
      smallImageCode,
      smallImageUrl,
    }) {
      this.formData.bigImageCode = bigImageCode
      this.formData.bigImageUrl = bigImageUrl
      this.formData.middleImageCode = middleImageCode
      this.formData.middleImageUrl = middleImageUrl
      this.formData.smallImageCode = smallImageCode
      this.formData.smallImageUrl = smallImageUrl
    },
    async salesChange(userCode) {
      const getUser = async () => {
        if (!userCode) return {}
        const res = await this.$api
          .sysUserDetailApi({ userCode })
          .catch(() => null)
        return res?.body || {}
      }

      const userInfo = await getUser()
      const { depCode, orgDepFullName } = userInfo
      this.formData.depCode = depCode
      this.formData.orgDepFullName = orgDepFullName
    },
  },
}
</script>

<style lang="scss" scoped>
.cust-logo-display {
  width: 50px;
  height: 50px;
  min-width: 50px;
  background-color: #f4f6f9;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #101010;
  font-size: 14px;
}
</style>
